<template>
  <TableLayout :permissions="['business:bikes:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编码" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间" @change="search"/>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入编辑人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="车辆类型编码（关联base_param)" prop="paramId">
        <el-input v-model="searchForm.paramId" placeholder="请输入车辆类型编码（关联base_param)" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编号" prop="code">
        <el-input v-model="searchForm.code" placeholder="请输入编号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态 0停车可出借 1出借中 3禁用 " prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入状态 0停车可出借 1出借中 3禁用 " @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="当前站点编码（关联sites)" prop="siteId">
        <el-input v-model="searchForm.siteId" placeholder="请输入当前站点编码（关联sites)" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="当前锁头编码（关联locks)" prop="lockId">
        <el-input v-model="searchForm.lockId" placeholder="请输入当前锁头编码（关联locks)" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="最近租借时间" prop="lastRentData">
        <el-date-picker v-model="searchForm.lastRentData" value-format="yyyy-MM-dd" placeholder="请输入最近租借时间" @change="search"/>
      </el-form-item>
      <el-form-item label="出售时间" prop="soldoutDate">
        <el-date-picker v-model="searchForm.soldoutDate" value-format="yyyy-MM-dd" placeholder="请输入出售时间" @change="search"/>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:bikes:create']">
        <li><el-button type="primary" @click="$refs.operaBikesWindow.open('新建自行车信息表')" icon="el-icon-plus" v-permissions="['business:bikes:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="paramId" label="车辆类型编码（关联base_param)" min-width="100px"></el-table-column>
        <el-table-column prop="code" label="编号" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0停车可出借 1出借中 3禁用 " min-width="100px"></el-table-column>
        <el-table-column prop="siteId" label="当前站点编码（关联sites)" min-width="100px"></el-table-column>
        <el-table-column prop="lockId" label="当前锁头编码（关联locks)" min-width="100px"></el-table-column>
        <el-table-column prop="lastRentData" label="最近租借时间" min-width="100px"></el-table-column>
        <el-table-column prop="soldoutDate" label="出售时间" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:bikes:update', 'business:bikes:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaBikesWindow.open('编辑自行车信息表', row)" icon="el-icon-edit" v-permissions="['business:bikes:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:bikes:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaBikesWindow ref="operaBikesWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaBikesWindow from '@/components/business/OperaBikesWindow'
export default {
  name: 'Bikes',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaBikesWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        name: '',
        info: '',
        paramId: '',
        code: '',
        status: '',
        siteId: '',
        lockId: '',
        lastRentData: '',
        soldoutDate: ''
      }
    }
  },
  created () {
    this.config({
      module: '自行车信息表',
      api: '/business/bikes',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
